export enum Breakpoint {
  Low = 10,
  LowAverage = 22,
  Average = 64,
  HighAverage = 76,
  High = 88,
  VeryHigh = 95,
  Exceptional = 100
}

export const getBreakpointClassName = (breakpoint: Breakpoint) => {
  switch (breakpoint) {
    case Breakpoint.Low:
      return 'low'
    case Breakpoint.LowAverage:
      return 'low-average'
    case Breakpoint.Average:
      return 'average'
    case Breakpoint.HighAverage:
      return 'high-average'
    case Breakpoint.High:
      return 'high'
    case Breakpoint.VeryHigh:
      return 'very-high'
    case Breakpoint.Exceptional:
      return 'exceptional'
    default:
      return ''
  }
}

export const getValueClassName = (val: number) => {
  for (const br of getBreakpointsArr()) {
    if (val <= br) {
      return getBreakpointClassName(br)
    }
  }
  return ''
}

export const getBreakpointsArr = () => {
  const res: Breakpoint[] = []
  for (const key in Breakpoint) {
    if (Breakpoint.hasOwnProperty(key) && Number.isNaN(+key)) {
      res.push(+Breakpoint[key])
    }
  }
  return res.sort((a, b) => a - b)
}

export const getBreakpointRange = (
  breakpoint: Breakpoint
): { start: number; end: number } | null => {
  const arr = getBreakpointsArr()
  const index = arr.findIndex(b => b === breakpoint)
  if (index === -1) {
    return null
  }
  return {
    start: index === 0 ? 0 : arr[index - 1],
    end: breakpoint
  }
}



// WEBPACK FOOTER //
// ./src/data/abitilies/Breakpoint.ts